<template>
  <v-card>
    <cliente-direcciones-form
      :direccion="direccion"
      :isUpdate="true"
      :loading="loading"
      @close-dialog="$emit('close-dialog')"
      @process-save="actualizarDireccion"
    ></cliente-direcciones-form>
  </v-card>
</template>

<script>
import ClienteDireccionesForm from "@/components/shared/clientes/direcciones/components/cliente.direccion.form.vue";
import ClienteDireccionesAPI from "@/api/clientes/direcciones.js";

export default {
  name: "DireccionUpdate",
  components: {
    ClienteDireccionesForm,
  },
  props: {
    direccion: {
      type: Object,
      required: true,
    },
    cliente_id: {
      required: true
    }
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    actualizarDireccion(direccion) {
      direccion.cliente = this.cliente_id;

      if (direccion.localidad && typeof direccion.localidad === 'object'){
        direccion.localidad = direccion.localidad.id;
      }
      if (direccion.barrio && typeof direccion.barrio === 'object'){
        direccion.barrio = direccion.barrio.id;
      }

      this.loading = true;
      ClienteDireccionesAPI.update(direccion)
        .then((response) => {
          this.$emit("updated-direccion", response.data);
          this.$emit('refresh-direcciones');
          this.$emit('close-dialog');
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "success",
            text: "Dirección actualizada",
            icon: "mdi-check",
            timeout: 2500,
          });
        })
        .catch((e) => {
          const msg = e.response?.data?.detail || "Error al actualizar dirección";
          this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "error",
            text: msg,
            icon: "mdi-alert",
            timeout: 3000,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
